import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";
import DashboardDoughnut from "../DashboardDoughnut";
import DoughnutLegend from "../DoughnutLegend";

import { calculatePercentage } from "../../../utils/data";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const styles = {
  doughnutContainer: {
    margin: "0px 20px",
    display: "flex",
    alignItems: "center",
  },
};

const MdcNbVisits = (props) => {
  const { classes, data } = props;

  const doughnutColors = [colors.dashboardDarkBlue, colors.dashboardLightBlue];

  return (
    <DashboardCard
      title={I18n.get("dashboard_numberOfVisits")}
      size={sizes.small}
      style={{
        margin: "12px",
        minWidth: "325px",
        flexGrow: 1,
      }}
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100%" }}
      >
        <Grid item className={classes.doughnutContainer}>
          <DashboardDoughnut
            values={[
              get(data, ["card1", "entrance"]),
              get(data, ["card1", "exit"]),
            ]}
            total={get(data, ["card1", "nbr_visits"])}
            colors={doughnutColors}
          />
        </Grid>
        <Grid
          item
          style={{ marginLeft: "10px", padding: "0px 14px", minWidth: "160px" }}
        >
          <Grid container direction="column">
            {map(["entrance", "exit"], (type, index) => (
              <DoughnutLegend
                key={type}
                color={doughnutColors[index]}
                title={I18n.get(`dashboard_${type}`)}
                value={get(data, ["card1", type])}
                percentage={calculatePercentage(
                  get(data, ["card1", type]),
                  get(data, ["card1", "nbr_visits"])
                )}
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </DashboardCard>
  );
};

export default withStyles(styles)(MdcNbVisits);
